export default [
  { title: 'Users', routeName: 'users' },

  { title: 'Requests', routeName: 'users-requests' },
];
